export default "__VITE_ASSET__Z9go7GlC__"